import { Button, Space } from '@/components';
import {
  type ProjectSearchFormType,
  ProjectSearchSchema,
  initialValueOfProjectSearchForm,
} from '@/features/search/_models/projects-search';
import dayjs from 'dayjs';
import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useCurrentFiscalYear } from '../../_hooks/get-current-fiscal-year';
import { useProjectsSearchStore } from '../../_stores/projects-search-store';

export const SearchButton: FC<{
  formId: string;
  onResetPayment: () => void;
}> = ({ formId, onResetPayment }) => {
  const { t } = useTranslation();
  const { reset } = useFormContext<ProjectSearchFormType>();
  const { type } = useProjectsSearchStore();
  const { getValues } = useFormContext<ProjectSearchFormType>();
  const currentFiscalYear = useCurrentFiscalYear();
  return (
    <Space>
      <Button
        htmlType="button"
        type="default"
        onClick={async () => {
          const nullifiedValues = Object.keys(ProjectSearchSchema.shape).reduce(
            (acc, key) => {
              acc[key] = null;
              return acc;
            },
            {} as Record<string, null>,
          );
          const { formulaConditions, fiscalYear, ...restInitialValue } =
            initialValueOfProjectSearchForm(
              currentFiscalYear.data ?? currentFiscalYear.basicFiscalYear,
            );

          reset({
            ...nullifiedValues,
            ...restInitialValue,
            formulaConditions: [formulaConditions],
            categories: null,
            fiscalYear:
              type === 'group'
                ? getValues('fiscalYear')
                : dayjs().year(fiscalYear),
          });
          onResetPayment();
        }}
      >
        {t('search-clear')}
      </Button>
      <Button form={formId} htmlType="submit" type="primary">
        {t('search-by')}
      </Button>
    </Space>
  );
};
